// useEnv — fetches env.defaults once on mount. Returns { model, cwd, ... }.
// Falls back to placeholder values if the call fails (e.g. user not
// logged in yet) so the chat shell can render without an error state.

import { useEffect, useState } from "preact/hooks";
import { api, type EnvDefaults } from "./rpc";

const FALLBACK: EnvDefaults = {
  userId: "",
  isAdmin: false,
  cwd: "",
  home: "",
  baseUrl: "",
  model: "—",
  maxContext: 0,
};

export function useEnv(): EnvDefaults {
  const [env, setEnv] = useState<EnvDefaults>(FALLBACK);
  useEffect(() => {
    let cancelled = false;
    api.envDefaults()
      .then((e) => { if (!cancelled) setEnv(e); })
      .catch(() => { /* keep fallback; auth interstitial handles 401 */ });
    return () => { cancelled = true; };
  }, []);
  return env;
}
